import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { FAQS } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="faq-section">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_1.6fr] lg:gap-16">
        <div>
          <SectionHeading
            index="07"
            eyebrow="FAQ"
            title="Common Questions"
            sub="Straight answers before you book. Anything else — just text us."
          />
        </div>
        <div className="divide-y divide-white/10 border-y border-white/10">
          {FAQS.map((item, i) => (
            <Reveal key={item.q} delay={i * 0.04} y={16}>
              <div>
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="flex w-full items-center justify-between gap-6 py-5 text-left"
                  aria-expanded={open === i}
                  data-testid={`faq-question-${i}`}
                >
                  <span className="font-display text-lg font-semibold uppercase tracking-wide text-white sm:text-xl">
                    {item.q}
                  </span>
                  <ChevronDown
                    size={19}
                    strokeWidth={2.2}
                    className={`shrink-0 text-blue-500 transition-transform duration-300 ${open === i ? "rotate-180" : ""}`}
                    aria-hidden="true"
                  />
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="max-w-2xl pb-6 pr-8 text-sm leading-relaxed text-slate-400 sm:text-base" data-testid={`faq-answer-${i}`}>
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
